import { createObservabilityId } from './ids';
import { normalizePath } from './privacy';
import { ObservabilityContext, RequestObservabilityContext } from './types';

const COGNITO_USER_ID_PATTERN = /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;

function initialRoute(): string {
  return normalizePath(globalThis.location?.pathname ?? '/');
}

let currentContext: ObservabilityContext = Object.freeze({
  correlationId: createObservabilityId(),
  route: initialRoute(),
});

let currentUserId: string | undefined;

function contextWithUser(correlationId: string, route: string): ObservabilityContext {
  return Object.freeze({
    correlationId,
    route,
    ...(currentUserId ? { userId: currentUserId } : {}),
  });
}

export function getObservabilityContext(): ObservabilityContext {
  return currentContext;
}

export function beginObservabilityContext(route: string, correlationId = createObservabilityId()): ObservabilityContext {
  currentContext = contextWithUser(correlationId, normalizePath(route));
  return currentContext;
}

export function setObservabilityUserId(userId?: string): ObservabilityContext {
  const normalized = userId?.trim();
  currentUserId = normalized && COGNITO_USER_ID_PATTERN.test(normalized) ? normalized : undefined;
  currentContext = contextWithUser(currentContext.correlationId, currentContext.route);
  return currentContext;
}

export function createRequestContext(): RequestObservabilityContext {
  return { ...currentContext, requestId: createObservabilityId() };
}
